import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, inject, Input, OnInit, signal, ViewChildren } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonVariant, QPointButtonComponent } from '@qpoint/buttons';
import { IconType, QPointIconModule } from '@qpoint/icons';

export type ConfirmDialogType = 'warning' | 'error' | 'success' | null;
export type QPointConfirmDialogButtonValue<T = string | number | boolean> = T;

export interface QPointConfirmDialogButtonConfig<T = QPointConfirmDialogButtonValue> {
  /**
   * optional, defaults to index
   */
  value?: T;
  text: string;
  variant?: ButtonVariant;
  icon?: {
    name: string;
    iconType?: IconType;
    iconVariant?: 'danger' | 'success' | 'warn' | 'primary';
  };
}

@Component({
    selector: 'qpoint-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    imports: [
        CommonModule,
        TranslateModule,
        QPointIconModule,
        QPointButtonComponent
    ]
})

export class QPointConfirmDialogComponent implements OnInit, AfterViewInit {
  private activeModal: NgbActiveModal = inject(NgbActiveModal);
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  isLoading = signal(false);

  @Input() title: string;
  @Input() message: string;
  /**
   * Buttons are rendered from right to left
   */
  @Input() buttons: QPointConfirmDialogButtonConfig[];
  @Input() confirmDialogType: ConfirmDialogType;
  @ViewChildren(QPointButtonComponent) buttonComponents: QPointButtonComponent[];

  get filteredButtons(): QPointConfirmDialogButtonConfig[] {
    return (this.buttons || []).filter(btn => !!btn.text && btn.text !== '')?.reverse();
  }

  ngOnInit() {
    this.isLoading.set(true);

  }

  ngAfterViewInit(): void {
    this.isLoading.set(false);
    setTimeout(() => {
      this.buttonComponents?.find(button => button.variant === ButtonVariant.primary)?.focus();
    })
    this.cdr.detectChanges();
  }

  public dismiss() {
    this.activeModal.dismiss();
  }

  buttonClicked(buttonConfig: QPointConfirmDialogButtonConfig, index: number) {
    this.activeModal.close({...buttonConfig, value: buttonConfig.value ?? index});
  }
}
